import client from "./requestclient";

const agentProfile = {
  smartAgentProfile: async () => {
    const token = localStorage.getItem("token");
    return await client({
      URL_PATH: `agent-profile`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  agentRequest: async (agentRequestPayload) => {
    return await client({
      URL_PATH: `agent-react-to-request`,
      method: "POST",
      body: agentRequestPayload,
    });
  },
  requestDetails: async (id) => {
    // const token = localStorage.getItem( "token");
    return await client({
      URL_PATH: `get-request-details/${id}`,

      method: "GET",
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //   },
    });
  },
  takeRequestAction: async (agentRequestPayload) => {
    // const token = localStorage.getItem( "token");
    return await client({
      URL_PATH: `agent-react-to-request`,
      method: "POST",
      body: agentRequestPayload,
    });
  },
  cancelRequestByAgent: async (agentRequestPayload) => {
    // const token = localStorage.getItem( "token");
    return await client({
      URL_PATH: `agent-cancel-request`,
      method: "POST",
      body: agentRequestPayload,
    });
  },

};

export default agentProfile;
